import {Injectable} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';

@Injectable({
  providedIn: 'root'
})
export class PsadjuntService {

  constructor(private crud: CrudService, private spring: Spring) {
  }


  getListPsadjuntByIdseguroPagos(idseguro: number) {
    return this.crud.get(`${this.spring.PSADJUNT_GET_LIST_BY_IDSEGURO_PAGOS}${idseguro}`);
  }


  getListPsadjuntByIdgenral(idgenral: number) {
    return this.crud.get(`${this.spring.PSADJUNT_GET_LIST_BY_IDGENRAL}${idgenral}`);
  }

  getListPsadjuntByIdgasdet(idgasdet: number) {
    return this.crud.get(`${this.spring.PSADJUNT_GET_LIST_BY_IDGASDET}${idgasdet}`);
  }

  getArchivo(archivo: string, rutaSFTP: string) {
    return this.crud.getText(`${this.spring.PSADJUNT_ARCHIVO}${archivo}&${rutaSFTP}`);
  }

  deleteAdjunt(idadjunt: number, ruta: string, archivo: string) {
    return this.crud.delete(`${this.spring.PSADJUNT_DELETE}${idadjunt}&${ruta}&${archivo}`);
  }

  existeComprobante(idmovimi: number) {
    return this.crud.getText(`${this.spring.PSADJUNT_EXISTE_COMPROBANTE_CXP}${idmovimi}`);
  }


}
